/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_To_HomeInputs */

const en_go_to_home = /** @type {(inputs: Go_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to home`)
};

const nl_go_to_home = /** @type {(inputs: Go_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar start`)
};

/**
* | output |
* | --- |
* | "Go to home" |
*
* @param {Go_To_HomeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const go_to_home = /** @type {((inputs?: Go_To_HomeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_To_HomeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_go_to_home(inputs)
	return en_go_to_home(inputs)
});